import React from 'react';
import './AboutSection.css';

function AboutSection() {
  const highlights = [
    {
      title: 'Transparent Operations',
      description: 'We maintain clear communication, honest partnerships, and straightforward business practices throughout all wholesale relationships.',
      icon: '○'
    },
    {
      title: 'Supplier Excellence',
      description: 'Strategic relationships with vetted suppliers ensure consistent quality, reliability, and long-term supply chain stability.',
      icon: '✓'
    },
    {
      title: 'Operational Integrity',
      description: 'Professional execution, scalable processes, and commitment to operational standards that support sustainable business growth.',
      icon: '⚙'
    }
  ];

  return (
    <section id="about" className="about-section">
      <div className="section-container">
        <div className="about-header">
          <h2>Active Wholesale Trading & Distribution</h2>
          <p className="about-intro">
            Northstar Bridge Commerce LLC is a U.S.-registered wholesale trading company focused on sourcing quality consumer products from vetted suppliers and distributing them through established online retail channels across the United States.
          </p>
          <p className="about-intro">
            We support the full operational process, including supplier onboarding, wholesale purchasing, inventory coordination, and fulfillment support through U.S.-based logistics partners.
          </p>
          <p className="about-intro">
            Our approach is centered on reliable partnerships, transparent operations, and consistent product quality.
          </p>
        </div>

        <div className="highlights-grid">
          {highlights.map((highlight, index) => (
            <div key={index} className="highlight-card">
              <div className="highlight-icon">{highlight.icon}</div>
              <h3>{highlight.title}</h3>
              <p>{highlight.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
